import { apiClient } from './authService';

const subcategoryService = {
  // Get all subcategories
  getAllSubcategories: async () => {
    try {
      const response = await apiClient.get('products/subcategories/');
      console.log('Raw subcategories API response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching subcategories:', error);
      throw error.response?.data || { message: 'Error fetching subcategories' };
    }
  },

  // Get subcategories by category ID
  getSubcategoriesByCategory: async (categoryId) => {
    try {
      const response = await apiClient.get(`products/subcategories/?category_id=${categoryId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching subcategories for category ${categoryId}:`, error);
      throw error.response?.data || { message: 'Error fetching subcategories for this category' };
    }
  },

  // Get subcategory by ID
  getSubcategoryById: async (id) => {
    try {
      const response = await apiClient.get(`products/subcategories/${id}/`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching subcategory ${id}:`, error);
      throw error.response?.data || { message: 'Error fetching subcategory details' };
    }
  },

  // Create new subcategory
  createSubcategory: async (subcategoryData) => {
    try {
      const response = await apiClient.post('products/subcategories/', subcategoryData);
      return response.data;
    } catch (error) {
      console.error('Error creating subcategory:', error);
      throw error.response?.data || { message: 'Error creating subcategory' };
    }
  },

  // Update subcategory
  updateSubcategory: async (id, subcategoryData) => {
    try {
      const response = await apiClient.put(`products/subcategories/${id}/`, subcategoryData);
      return response.data;
    } catch (error) {
      console.error(`Error updating subcategory ${id}:`, error);
      throw error.response?.data || { message: 'Error updating subcategory' };
    }
  },

  // Delete subcategory
  deleteSubcategory: async (id) => {
    try {
      const response = await apiClient.delete(`products/subcategories/${id}/`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting subcategory ${id}:`, error);
      throw error.response?.data || { message: 'Error deleting subcategory' };
    }
  }
};

export default subcategoryService;
